/* eslint-disable */
import get from 'lodash/get';
import last from 'lodash/last';
import head from 'lodash/head';
import moment from 'moment';
import { sortDates, getDate } from './utils';

// App Constants
import { BASIC, BASIC_ANUAL, PRO, PRO_ANUAL } from '../constants/app';
import {
  CREDITS_OPTION_ONE,
  CREDITS_OPTION_TWO,
  CREDITS_OPTION_THREE,
  CREDITS_OPTION_FOUR
} from '../constants/subscriptions';

// Templates
import { HEX_ACTIVE_GREEN, HEX_INACTIVE_GREY, HEX_APP_BLUE } from '../constants/colors';

// Const
import {
  NEW_DUE_DATE_TEMPLATE,
  NEW_EARLY_REMINDER_TEMPLATE,
  NEW_LATE_PAYMENT_TEMPLATE,
  NEW_RECEIPT_TEMPLATE,
  NEW_SEND_INVOICE_TEMPLATE,
  NEW_ACCOUNT_STATEMENT_TEMPLATE,
  NEW_DUE_DATE_TEMPLATE_SMS,
  NEW_EARLY_REMINDER_TEMPLATE_SMS,
  NEW_LATE_PAYMENT_TEMPLATE_SMS,
  NEW_RECEIPT_TEMPLATE_SMS,
  NEW_SEND_INVOICE_TEMPLATE_SMS,
  NEW_ACCOUNT_STATEMENT_TEMPLATE_SMS,
  NEW_EMISSION_INVOICE_TEMPLATE_SMS
} from '../redux/actions/templateActions';

/*                 __                                     __      _           __
  _______  _______/ /_____  ____ ___  ___  _____   ____  / /_    (_)__  _____/ /_
 / ___/ / / / ___/ __/ __ \/ __ `__ \/ _ \/ ___/  / __ \/ __ \  / / _ \/ ___/ __/
/ /__/ /_/ (__  ) /_/ /_/ / / / / / /  __/ /     / /_/ / /_/ / / /  __/ /__/ /_
\___/\__,_/____/\__/\____/_/ /_/ /_/\___/_/      \____/_.___/_/ /\___/\___/\__/
                                                           /___/ */

export const customer = {};

let customer_tabs = (customer.getTabMeta = function (value) {
  switch (value) {
    case 2:
    case 'incomplete':
      return {
        tabNumber: 3,
        name: 'incomplete'
      }; // END return

    case 3:
    case 'frequent':
      return {
        tabNumber: 3,
        name: 'frequent'
      }; // END return

    case 4:
    case 'favorite':
      return {
        tabNumber: 4,
        name: 'favorite'
      }; // END return

    case 5:
    case 'unused':
      return {
        tabNumber: 5,
        name: 'unused'
      }; // END return

    case 1:
    case 'all':
    default:
      return {
        tabNumber: 1,
        name: 'all'
      }; // END return
  } // END switch
}); // END customer_tabs

/*  ____                 _                    __      _           __
   /  _/___ _   ______  (_)_______     ____  / /_    (_)__  _____/ /_
   / // __ \ | / / __ \/ / ___/ _ \   / __ \/ __ \  / / _ \/ ___/ __/
 _/ // / / / |/ / /_/ / / /__/  __/  / /_/ / /_/ / / /  __/ /__/ /_
/___/_/ /_/|___/\____/_/\___/\___/   \____/_.___/_/ /\___/\___/\__/
                                               /___/               */

export const invoice = {};

let invoice_tabs = (invoice.getTabMeta = function (value) {
  switch (value) {
    case 2:
    case 'paid':
      return {
        tabNumber: 2,
        name: 'paid'
      }; // END return

    case 3:
    case 'late_payment':
      return {
        tabNumber: 3,
        name: 'late_payment'
      }; // END return

    case 4:
    case 'uncollectable':
      return {
        tabNumber: 4,
        name: 'uncollectable'
      }; // END return

    case 6:
    case 'cancel':
      return {
        tabNumber: 6,
        name: 'cancel'
      }; // END return

    default:
    case 1:
      return {
        tabNumber: 1,
        name: 'default'
      }; // END return
  } // END switch
}); // END invoice_tabs

let invoice_status = (invoice.getStatus = function (statusId) {
  switch (parseInt(statusId)) {
    case 1:
      return {
        value: 'Borrador',
        color: '#193b86',
        i18: 'invoices.status.payed'
      }; // END case

    case 2:
      return {
        value: 'Creada',
        color: '#3c13f9',
        i18: 'invoices.status.canceled'
      }; // END case

    case 3:
      return {
        value: 'Enviada',
        color: '#f98e6a',
        i18: 'invoices.status.imported'
      }; // END case

    case 4:
      return {
        value: 'Vista',
        color: '#7e0adb',
        i18: 'invoices.status.imported'
      }; // END case

    case 5:
      return {
        value: 'Pagada',
        color: '#28bd52',
        i18: 'invoices.status.imported'
      }; // END case

    case 6:
      return {
        value: 'Importada',
        color: '#c533bb',
        i18: 'invoices.status.imported'
      }; // END case

    default:
      return {
        value: 'No disponible',
        color: '#314e7d',
        i18: 'invoices.common.unavailable'
      }; // END case
  } // END switch
}); // END invoice_status

let invoice_cancel_status = (invoice.getCancelStatus = function (status) {
  switch (status) {
    case 'canceled':
      return {
        value: 'Cancelada',
        color: '#9D9AAA',
        i18: 'cancel.status.canceled'
      }; // END case

    case 'active':
      return {
        value: 'Activa',
        color: '#187EFF',
        i18: 'cancel.status.active'
      }; // END case

    case 'pending':
      return {
        value: 'Pendiente',
        color: '#F7B500',
        i18: 'cancel.status.pending'
      }; // END case

    case 'acepted':
      return {
        value: 'Aceptada',
        color: '#9D9AAA',
        i18: 'cancel.status.acepted'
      }; // END case

    case 'rejected':
      return {
        value: 'Rechazada',
        color: '#E9494E',
        i18: 'cancel.status.rejected'
      }; // END case

    case 'expired':
      return {
        value: 'Expirada',
        color: '#9D9AAA',
        i18: 'cancel.status.expired'
      }; // END case

    default:
      return {
        value: 'No disponible',
        color: '',
        i18: 'invoices.common.unavailable'
      }; // END case
  } // END switch
}); // END invoice_status

let invoice_payment_term = (invoice.getTerm = function (term) {
  let n = parseInt(term),
    noCred = { value: 'Al contado', i18: 'invoices.common.unavailable' };

  if (isNaN(n)) return noCred;
  else if (n === 0) return noCred;
  else return { value: `${n} días`, i18: 'invoices.common.days' };
}); // END invoice_payment_agreement

let invoice_payment_agreement = (invoice.getAgreement = function (agreementId) {
  switch (parseInt(agreementId)) {
    case 1:
      return {
        value: 'Al contado',
        i18: 'invoices.agreement.instant'
      }; // END case

    default:
      return {
        value: 'Sin crédito',
        i18: 'invoices.common.unavailable'
      }; // END case
  } // END switch
}); // END invoice_payment_agreement

/*  ____                                   __           __      _           __
   / __ \____ ___  ______ ___  ___  ____  / /_   ____  / /_    (_)__  _____/ /_
  / /_/ / __ `/ / / / __ `__ \/ _ \/ __ \/ __/  / __ \/ __ \  / / _ \/ ___/ __/
 / ____/ /_/ / /_/ / / / / / /  __/ / / / /_   / /_/ / /_/ / / /  __/ /__/ /_
/_/    \__,_/\__, /_/ /_/ /_/\___/_/ /_/\__/   \____/_.___/_/ /\___/\___/\__/
            /____/                                       /___/                */

export const payment = {};

let payment_tabs = (payment.getTabMeta = function (value) {
  switch (value) {
    default:
    case 1:
      return {
        tabNumber: 1,
        name: 'Todo'
      }; // END return
  } // END switch
}); // END payment_tabs

let payment_validation = (payment.getValidation = function (statusId) {
  if (statusId === 1)
    return {
      value: 'Por Confirmar',
      color: '#2692b0'
    }; // END if

  if (statusId === 2)
    return {
      value: 'Confirmado',
      color: '#4bbc68'
    }; // END if

  if (statusId === 3)
    return {
      value: 'Rechazado',
      color: '#E9494E'
    }; // END if

  if (statusId === 6)
    return {
      value: 'Cancelado',
      color: '#8E8E8E'
    }; // END if

  return {
    value: 'No disponible'
  }; // END if
}); // END getValidation

let payment_status = (payment.getStatus = function (statusId, dueDate, typeDocument) {
  if (statusId === 5)
    return {
      value: 'Pagado',
      color: '#4bbc68',
      i18: 'payments.status.payed'
    }; // END return

  if (statusId === 6)
    return {
      value: 'Cancelada',
      color: '#8E8E8E',
      i18: 'payments.status.canceled'
    }; // END return

  if (statusId === 2 && typeDocument === 'E')
    return {
      value: 'Emitida',
      color: '#4bbc68',
      i18: 'payments.status.to_issue'
    }; // END return

  if (statusId === 1)
    return {
      value: 'Por Emitir',
      color: '#6c757d',
      i18: 'payments.status.to_emit'
    }; // END return

  if (statusId === 0)
    return {
      value: 'Por Emitir',
      color: '#6c757d',
      i18: 'payments.status.to_issue'
    }; // END return

  if (!moment(dueDate).isValid())
    return {
      value: 'No disponible',
      i18: 'payments.status.payed'
    }; // END return

  const today = moment().add(1, 'DAYS').format('YYYY-MM-DD');
  const dueDateString = moment.unix(dueDate).format('YYYY-MM-DD');
  const isDue = moment(dueDateString).isBefore(today); //true

  if (statusId != 5) {
    if (isDue) {
      return {
        value: 'Vencido',
        color: '#E9494E',
        i18: 'payments.status.due'
      }; // END return
    } else if (!isDue) {
      return {
        value: 'Vigente',
        color: '#2692b0',
        i18: 'payments.status.pending'
      }; // END return
    } // END if
  } // END if

  return {
    value: 'No disponible',
    i18: 'payments.status.payed'
  }; // END return
}); // END payment_status

let is_payed = (payment.isPayed = function (statusId) {
  switch (parseInt(statusId)) {
    case 5:
      return {
        value: 'Pagado',
        color: '#53b9c8',
        boolean: true,
        i18: 'payments.isPayed'
      }; // END case

    default:
      return {
        value: 'Pendiente',
        color: '#646777',
        boolean: false,
        i18: 'payments.isNotPayed'
      }; // END case
  } // END switch
}); // END payment_status

let payment_type = (payment.getType = function (typeId) {
  switch (parseInt(typeId)) {
    case 1:
      return {
        value: 'Efectivo',
        i18: 'payments.type.x'
      };

    case 2:
      return {
        value: 'Cheque nominativo',
        i18: 'payments.type.x'
      };

    case 3:
      return {
        value: 'Transferencia de fondos',
        i18: 'payments.type.x'
      };

    case 4:
      return {
        value: 'Tarjeta de crédito',
        i18: 'payments.type.x'
      };

    case 5:
      return {
        value: 'Monedero electrónico',
        i18: 'payments.type.x'
      };

    case 6:
      return {
        value: 'Dinero electrónico',
        i18: 'payments.type.x'
      };

    case 7:
      return {
        value: 'Tarjetas digitales',
        i18: 'payments.type.x'
      };

    case 8:
      return {
        value: 'Vales de despensa',
        i18: 'payments.type.x'
      };

    case 12:
      return {
        value: 'Dación en pago',
        i18: 'payments.type.x'
      };

    case 13:
      return {
        value: 'Pago por subrogación',
        i18: 'payments.type.x'
      };

    case 14:
      return {
        value: 'Pago por consignación',
        i18: 'payments.type.x'
      };

    case 15:
      return {
        value: 'Condonación',
        i18: 'payments.type.x'
      };

    case 17:
      return {
        value: 'Compensación',
        i18: 'payments.type.x'
      };

    case 23:
      return {
        value: 'Novación',
        i18: 'payments.type.x'
      };

    case 24:
      return {
        value: 'Confusión',
        i18: 'payments.type.x'
      };

    case 25:
      return {
        value: 'Remisión de deuda',
        i18: 'payments.type.x'
      };

    case 26:
      return {
        value: 'Prescripción o caducidad',
        i18: 'payments.type.x'
      };

    case 27:
      return {
        value: 'A satisfacción del acreedor',
        i18: 'payments.type.x'
      };

    case 28:
      return {
        value: 'Tarjeta de débito',
        i18: 'payments.type.x'
      };

    case 29:
      return {
        value: 'Tarjeta de servicios',
        i18: 'payments.type.x'
      };

    case 30:
      return {
        value: 'Aplicación de anticipos',
        i18: 'payments.type.x'
      };

    case 99:
      return {
        value: 'Por definir',
        i18: 'payments.type.x'
      };

    default:
      return {
        value: 'No disponible',
        i18: 'payments.common.unavailable'
      }; // END case
  } // END switch
}); // END payment_type

let last_payment_date = (payment.lastPaymentDate = function (transactions) {
  let dates = [];

  if (head(transactions)) {
    transactions.forEach(transaction => {
      const date = get(transaction, 'paid_at');
      if (date) dates.push(date);
    }); // END forEach

    const daaaaas = sortDates(dates);
    const xDate = last(daaaaas);

    return getDate(xDate);
  } else {
    return 'No disponible';
  } // END if
}); // END payment_status

let payment_source = (payment.getSource = function (source) {
  switch (source) {
    case 'AR':
      return {
        value: 'Registro Manual',
        shortValue: 'Manual'
      }; // END case

    case 'BAR':
      return {
        value: 'Generado automáticamente para facturas PUE',
        shortValue: 'Automático'
      };

    case 'SPEI':
      return {
        value: 'SPEI',
        shortValue: 'SPEI'
      }; // END case

    case 'STRIPE':
      return {
        value: 'Stripe',
        shortValue: 'Stripe'
      };

    case 'OXXO':
      return {
        value: 'Oxxo',
        shortValue: 'Oxxo'
      };

    case 'OXXO_PUBLIC':
      return {
        value: 'Oxxo',
        shortValue: 'Oxxo'
      };

    case 'PAR':
      return {
        value: 'Comprobante de pago',
        shortValue: 'Comprobante'
      };

    case 'SAT':
      return {
        value: 'SAT',
        shortValue: 'SAT'
      };

    case 'CONTPAQI':
      return {
        value: 'CONTPAQI',
        shortValue: 'CONTPAQI'
      };

    case 'CONEKTA':
      return {
        value: 'Conekta',
        shortValue: 'Conekta'
      };

    case 'XML':
      return {
        value: 'Importación de XML',
        shortValue: 'XML'
      };

    case 'FISERV':
      return {
        value: 'Fiserv',
        shortValue: 'Fiserv'
      };

    case 'KUSHKI':
      return {
        value: 'Kushki',
        shortValue: 'Kushki'
      };

    case 'OPENPAY':
      return {
        value: 'Openpay',
        shortValue: 'Openpay'
      };
    case 'payfac':
      return {
        value: 'Paystand - Tarjeta',
        shortValue: 'Paystand - Tarjeta'
      };
    case 'bank_sync':
      return {
        value: 'Bank sync',
        shortValue: 'Bank sync'
      };
    default:
      return {
        value: 'No disponible',
        shortValue: 'No dis'
      }; // END case
  } // END switch
}); // END payment_status

/* ______      ____          __  _
  / ____/___  / / /__  _____/ /_(_)___  ____
 / /   / __ \/ / / _ \/ ___/ __/ / __ \/ __ \
/ /___/ /_/ / / /  __/ /__/ /_/ / /_/ / / / /
\____/\____/_/_/\___/\___/\__/_/\____/_/ /_/ */

export const collection = {};

let collection_status = (collection.getStatus = function (statusId) {
  switch (parseInt(statusId)) {
    case 0:
      return {
        value: 'Desactivada',
        color: HEX_APP_BLUE,
        boolean: false,
        i18: 'collections.status.canceled'
      }; // END case

    case 1:
      return {
        value: 'Activada',
        color: HEX_ACTIVE_GREEN,
        boolean: true,
        i18: 'collections.status.payed'
      }; // END case

    default:
      return {
        value: 'No disponible',
        color: HEX_INACTIVE_GREY,
        boolean: false,
        i18: 'collections.common.unavailable'
      }; // END case
  } // END switch
}); // END payment_status

let collection_state = (collection.getState = function (stateId) {
  switch (parseInt(stateId)) {
    case 0:
      return {
        value: 'Programado',
        i18: 'collections.state.pending'
      }; // END case

    case 1:
      return {
        value: 'Enviado',
        i18: 'collections.state.sent'
      }; // END case

    default:
      return {
        value: 'No disponible',
        i18: 'collections.common.unavailable'
      }; // END case
  } // END switch
}); // END payment_status

let collection_mode = (collection.getMode = function (modeId) {
  switch (parseInt(modeId)) {
    case 0:
      return {
        value: 'Automático',
        i18: 'collections.mode.automatic'
      }; // END case

    case 1:
      return {
        value: 'Manual',
        i18: 'collections.mode.manual'
      }; // END case

    default:
      return {
        value: 'No disponible',
        i18: 'collections.common.unavailable'
      }; // END case
  } // END switch
}); // END payment_status

let collection_action = (collection.getAction = function (actionId) {
  switch (parseInt(actionId)) {
    case 1:
      return {
        value: 'Correo',
        i18: 'collections.action.email'
      }; // END case

    case 2:
      return {
        value: 'SMS',
        i18: 'collections.action.sms'
      }; // END case

    case 3:
      return {
        value: 'WhatsApp',
        i18: 'collections.action.whatsapp'
      }; // END case

    case 4:
      return {
        value: 'Llamada IA',
        i18: 'collections.action.voice_call'
      }; // END case

    default:
      return {
        value: 'No disponible',
        i18: 'collections.common.unavailable'
      }; // END case
  } // END switch
}); // END payment_status

let collection_activity = (collection.getCollectionActivity = function (activities) {
  activities = activities.sort((a, b) => a + b);
  const last_event = get(last(activities), 'event_id');
  const activity = last(activities);
  switch (parseInt(last_event)) {
    case 1:
      return {
        value: 'Enviado',
        id: last_event,
        activity: activity,
        i18: 'collections.activity_event.receive'
      }; // END case

    case 2:
      return {
        value: 'Visto',
        id: last_event,
        activity: activity,
        i18: 'collections.activity_event.seen'
      }; // END case

    case 3:
      return {
        value: 'Rechazado',
        id: last_event,
        activity: activity,
        i18: 'collections.activity_event.reject'
      };

    default:
      return {
        value: 'Programado',
        id: last_event || 0,
        activity: activity,
        i18: 'collections.common.unavailable'
      }; // END case
  } // END switch
}); // END collection_activity

let next_collection = (collection.getNextCollectionMessage = function (activities) {
  const next_event = head(activities);
  switch (parseInt(get(next_event, 'event_id'))) {
    case 1:
      return {
        value: 'Recibido',
        ...next_event,
        i18: 'collections.activity_event.receive'
      }; // END case

    case 2:
      return {
        value: 'Visto',
        ...next_event,
        i18: 'collections.activity_event.seen'
      }; // END case

    default:
      return {
        value: 'Programado',
        ...next_event,
        i18: 'collections.common.unavailable'
      }; // END case
  } // END switch
}); // END next_collection

/*                      _ __
  ___  ____ ___  ____ _(_) /
 / _ \/ __ `__ \/ __ `/ / /
/  __/ / / / / / /_/ / / /
\___/_/ /_/ /_/\__,_/_/_/ */

export const email = {};

let email_template = (email.getTemplate = function (value) {
  switch (parseInt(value)) {
    case 1:
    case 'last_message':
    case NEW_DUE_DATE_TEMPLATE:
      return {
        value: 'Due Date',
        storeKey: 'last_message',
        id: 1,
        action: NEW_DUE_DATE_TEMPLATE,
        i18: 'email.template.due'
      }; // END case

    case 2:
    case 'collection':
    case NEW_LATE_PAYMENT_TEMPLATE:
      return {
        value: 'Activada',
        storeKey: 'collection',
        id: 2,
        action: NEW_LATE_PAYMENT_TEMPLATE,
        i18: 'email.template.late'
      }; // END case

    case 3:
    case 'invoice':
    case NEW_RECEIPT_TEMPLATE:
      return {
        value: 'Activada',
        storeKey: 'invoice',
        id: 3,
        action: NEW_RECEIPT_TEMPLATE,
        i18: 'email.template.receipt'
      }; // END case

    case 4:
    case 'receipt':
    case NEW_EARLY_REMINDER_TEMPLATE:
      return {
        value: 'Activada',
        storeKey: 'receipt',
        id: 4,
        action: NEW_EARLY_REMINDER_TEMPLATE,
        i18: 'email.template.early'
      }; // END case

    case 5:
    case 'new_invoice':
    case NEW_SEND_INVOICE_TEMPLATE:
      return {
        value: 'Enviada',
        storeKey: 'new_invoice',
        id: 5,
        action: NEW_SEND_INVOICE_TEMPLATE
      }; // END case

    case 6:
    case 'account_statement':
    case NEW_ACCOUNT_STATEMENT_TEMPLATE:
      return {
        value: 'Enviado',
        storeKey: 'account_statement',
        id: 6,
        action: NEW_ACCOUNT_STATEMENT_TEMPLATE
      }; // END case

    default:
      return {
        value: 'No disponible',
        action: null,
        i18: 'common.unavailable'
      }; // END case
  } // END switch
}); // END getTemplate

let emailTemplateId = (email.parseTemplateId = function (templateId, templates = []) {
  switch (templateId) {
    case '1':
      return {
        selfId: 5,
        formSection: 'SEND_INVOICE_TEMPLATE_EDITOR',
        editor: templates[0]
      };

    case '2':
      return {
        selfId: 4,
        formSection: 'EARLY_REMINDER_TEMPLATE_EDITOR',
        editor: templates[1]
      };

    case '3':
      return {
        selfId: 1,
        formSection: 'DUE_DATE_TEMPLATE_EDITOR',
        editor: templates[2]
      };

    case '4':
      return {
        selfId: 2,
        formSection: 'LATE_PAYMENT_TEMPLATE_EDITOR',
        editor: templates[3]
      };

    case '5':
      return {
        selfId: 3,
        formSection: 'RECEIPT_TEMPLATE_EDITOR',
        editor: templates[4]
      };

    case '6':
      return {
        selfId: 6,
        formSection: 'ACCOUNT_STATEMENT_TEMPLATE_EDITOR',
        editor: templates[5]
      };

    case '7':
      return {
        selfId: 7,
        formSection: 'RECEIPT_PAYMENT_TEMPLATE_EDITOR',
        editor: templates[6]
      };

    default:
      return {};
  }
}); // END parseTemplateId

// <=================== SMS ==============================>

export const sms = {};

let sms_template = (sms.getTemplate = function (value) {
  switch (parseInt(value)) {
    case 1:
    case 'last_message':
    case NEW_DUE_DATE_TEMPLATE_SMS:
      return {
        value: 'Due Date',
        storeKey: 'last_message',
        id: 1,
        action: NEW_DUE_DATE_TEMPLATE_SMS,
        i18: 'email.template.due'
      }; // END case

    case 2:
    case 'collection':
    case NEW_LATE_PAYMENT_TEMPLATE_SMS:
      return {
        value: 'Activada',
        storeKey: 'collection',
        id: 2,
        action: NEW_LATE_PAYMENT_TEMPLATE_SMS,
        i18: 'email.template.late'
      }; // END case

    case 3:
    case 'invoice':
    case NEW_RECEIPT_TEMPLATE_SMS:
      return {
        value: 'Activada',
        storeKey: 'invoice',
        id: 3,
        action: NEW_RECEIPT_TEMPLATE_SMS,
        i18: 'email.template.receipt'
      }; // END case

    case 4:
    case 'receipt':
    case NEW_EARLY_REMINDER_TEMPLATE_SMS:
      return {
        value: 'Activada',
        storeKey: 'receipt',
        id: 4,
        action: NEW_EARLY_REMINDER_TEMPLATE_SMS,
        i18: 'email.template.early'
      }; // END case

    case 5:
    case 'new_invoice':
    case NEW_EMISSION_INVOICE_TEMPLATE_SMS:
      return {
        value: 'Enviada',
        storeKey: 'new_invoice',
        id: 5,
        action: NEW_EMISSION_INVOICE_TEMPLATE_SMS
      }; // END case

    case 6:
    case 'account_statement':
    case NEW_ACCOUNT_STATEMENT_TEMPLATE_SMS:
      return {
        value: 'Enviado',
        storeKey: 'account_statement',
        id: 6,
        action: NEW_ACCOUNT_STATEMENT_TEMPLATE_SMS
      }; // END case

    case 7:
    case 'new_invoice':
    case NEW_SEND_INVOICE_TEMPLATE_SMS:
      return {
        value: 'Enviada',
        storeKey: 'new_invoice',
        id: 5,
        action: NEW_SEND_INVOICE_TEMPLATE_SMS
      }; // END case

    default:
      return {
        value: 'No disponible',
        action: null,
        i18: 'common.unavailable'
      }; // END case
  } // END switch
}); // END getTemplate

let sms_cancel_template = (sms.getCancelTemplate = function (cfdiType) {
  switch (cfdiType) {
    case 'I':
      return {
        cancel: '${team_name} : se canceló la factura ${invoice.code}, UUID fiscal ${invoice.attributes.cfdi_uuid}.',
        pending:
          '${team_name} : se solicitó la cancelación de la factura ${invoice.code}, UUID fiscal ${invoice.attributes.cfdi_uuid} ${url_pdf}.'
      }; // END case

    case 'P':
      return {
        cancel:
          '${team_name} : se canceló el pago ${payment.number}, UUID fiscal ${payment.attributes.cfdi_uuid} ${url_pdf}',
        pending:
          '${team_name} : se solicitó la cancelación del pago ${payment.number}, UUID fiscal ${payment.attributes.cfdi_uuid}'
      }; // END case

    case 'E':
      return {
        cancel:
          '${team_name} : se canceló la nota de crédito ${creditNote.code}, UUID fiscal ${creditNote.attributes.cfdi_uuid}.',
        pending:
          '${team_name} : se solicitó la cancelación de la nota de crédito ${creditNote.code}, UUID fiscal ${creditNote.attributes.cfdi_uuid} ${url_pdf}.'
      }; // END case

    default:
      return {
        value: 'No disponible',
        action: null,
        i18: 'common.unavailable'
      }; // END case
  } // END switch
}); // END sms_cancel_template

/*  _       __                        __  _
   (_)___  / /____  ____ __________ _/ /_(_)___  ____  _____
  / / __ \/ __/ _ \/ __ `/ ___/ __ `/ __/ / __ \/ __ \/ ___/
 / / / / / /_/  __/ /_/ / /  / /_/ / /_/ / /_/ / / / (__  )
/_/_/ /_/\__/\___/\__, /_/   \__,_/\__/_/\____/_/ /_/____/
                 /____/ */

export const integrations = {};

let integrations_ids = (integrations.getIntegration = function (value) {
  switch (parseInt(value)) {
    case 1:
    case 'SAT':
      return {
        id: 1,
        name: 'sat',
        value: 'Integración SAT',
        i18: 'integrations.sat'
      }; // END case

    case 7:
    case 'SAT_DOWNLOADS':
      return {
        id: 7,
        name: 'sat_downloads',
        value: 'Integración Descargas SAT',
        i18: 'integrations.sat_downloads'
      }; // END case

    case 2:
    case 'MANUAL_PAYMENT':
      return {
        id: 2,
        name: 'manualPayment',
        value: 'Integración Pago Manual',
        i18: 'integrations.manualPayment'
      }; // END case

    case 3:
    case 'SPEI':
      return {
        id: 2,
        name: 'spei',
        value: 'Integración SPEI',
        i18: 'integrations.spei'
      }; // END case

    case 4:
    case 'STRIPE':
      return {
        id: 4,
        name: 'stripe',
        value: 'Integración Stripe',
        i18: 'integrations.stripe'
      }; // END case

    case 5:
    case 'CONEKTA':
      return {
        id: 5,
        name: 'conekta',
        value: 'Integración Conekta',
        i18: 'integrations.conekta'
      }; // END case

    case 6:
    case 'OXXO':
      return {
        id: 6,
        name: 'oxxo',
        value: 'Integración Oxxo',
        i18: 'integrations.oxxo'
      }; // END case

    case 8:
    case 'CONTPAQI':
      return {
        id: 8,
        name: 'contpaqi',
        value: 'Integración Contpaqi',
        i18: 'integrations.contpaqi'
      }; // END case

    case 10:
    case 'FISERV':
      return {
        id: 10,
        name: 'fiserv',
        value: 'Integración Fiserv',
        i18: 'integrations.fiserv'
      }; // END case

    case 16:
    case 'PAYFAC':
      return {
        id: 16,
        name: 'payfac',
        value: 'Integración Payfac',
        i18: 'integrations.payfac'
      }; // END case

    default:
      return {
        value: 'No disponible',
        id: null,
        name: null,
        i18: 'common.unavailable'
      }; // END case
  } // END switch
}); // END getIntegration

//Parsing Country Code

export const profile = {};

let country_code = (profile.parseCountryCode = function (value) {
  switch (value) {
    case 'MEX':
      return {
        value: 'MEX',
        label: 'México'
      }; // END case

    case 'USA':
      return {
        value: 'USA',
        label: 'Estados Unidos'
      }; // END case

    default:
      return {
        value: null,
        label: 'Selecciona un país'
      }; // END case
  } // END switch
}); // END parseCountryCode

// --------------- TOBBAR NOTIFICATIONS ---------------

export const topBarNotifications = {};

let topBarNotificationEvent = (topBarNotifications.parseTopbarNotifications = function (
  notificationObject,
  parseTopbarNotificationsDate
) {
  switch (get(notificationObject, 'event')) {
    case 'collection_workflow_executed':
      return {
        title: 'Recordatorio automático enviado',
        message: `Se han enviado ${get(notificationObject, 'params.counter')} recordatorios de ${get(
          notificationObject,
          'params.counter'
        )} facturas`,
        client: '',
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: ''
      }; // END case
      break;

    case 'invoice_sync':
      return {
        title: 'Descarga de facturas del SAT',
        message: `${get(notificationObject, 'params.counter')} facturas descargadas`,
        client: '',
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: '/app/invoices'
      }; // END case
      break;

    case 'reminder_seen':
      return {
        title: 'Recordatorio visto',
        message: `/ Factura ${get(notificationObject, 'params.invoice.code')}`,
        client: get(notificationObject, 'params["customer.name"]'),
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: `/app/invoice/detail/${get(notificationObject, 'params.invoice.uuid')}`
      }; // END case
      break;

    case 'self_invoicing_generated':
      return {
        title: 'Factura creada por tu cliente',
        message: ` creo la factura ${get(
          notificationObject,
          'params.invoice.code'
        )} correspondiente a la nota de venta ${get(notificationObject, 'params.invoice.nv_code')}`,
        client: get(notificationObject, 'params.customer.name'),
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: `/app/invoice/detail/${get(notificationObject, 'params.invoice.uuid')}`
      }; // END case
      break;

    case 'reminder_bounce':
      return {
        title: 'Un recordatorio no puede ser entregado',
        message: `/ Factura ${get(
          notificationObject,
          'params.invoice.code'
        )}, el correo puede ser erróneo o no puede recibir más correos.`,
        client: get(notificationObject, 'params.customer.name'),
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: `/app/invoice/detail/${get(notificationObject, 'params.invoice.uuid')}`
      }; // END case
      break;

    case 'statement_reminder_seen':
      return {
        title: 'Estado de cuenta visto',
        message: `/ ${get(notificationObject, 'params.invoices.total')} facturas`,
        client: get(notificationObject, 'params.customer.name'),
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: `/app/customer/${get(notificationObject, 'params.customer.uuid')}`
      }; // END case
      break;

    case 'statement_reminder_bounce':
      return {
        title: 'Recordatorio de Estado de cuenta no entregado',
        message: `/ ${get(
          notificationObject,
          'params.invoices.total'
        )} facturas, el correo puede ser erróneo o no puede recibir más correos.`,
        client: get(notificationObject, 'params.customer.name'),
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: `/app/customer/${get(notificationObject, 'params.customer.uuid')}`
      }; // END case
      break;

    case 'invoice_contract_generated':
      return {
        title: 'Factura creada a partir de contrato',
        message: `Factura ${get(notificationObject, 'params.invoice.code')} de contrato ${get(
          notificationObject,
          'params.contract.code',
          get(notificationObject, 'params.contract.uuid')
        )}`,
        client: '',
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: `/app/invoice/detail/${get(notificationObject, 'params.invoice.uuid')}`
      }; // END case
      break;
    case 'payment_of_invoice_sync_to_sap_b1':
      return {
        title: 'Pago recibido exitosamente en SAP B1',
        message: `El pago de la factura ${get(
          notificationObject,
          'params.invoice.code'
        )} se registró exitosamente en SAP B1`,
        client: '',
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: `/app/invoice/detail/${get(notificationObject, 'params.invoice.uuid')}`
      }; // END case
      break;

    case 'reminder_buy_anniversary_plan':
      return {
        title: 'Free trial',
        message: `Tu prueba vence en ${moment(get(notificationObject, 'params.subscription.end')).diff(
          moment(),
          'days'
        )} días. Te recomendamos adquirir el plan Anniversary`,
        client: '',
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: get(notificationObject, 'path')
      };

    case 'error_generating_invoice_through_contract':
      const count = Number(get(notificationObject, 'params.count_contract_failed', '1'));
      return {
        title: `No pudimos generar ${count > 1 ? 'tus contratos' : 'tu contrato'}`,
        message: `Te enviamos mas información por correo electrónico`,
        client: '',
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: window.location.pathname
      };

    case 'ciec_authentication_failed':
      return {
        title: 'CIEC Incorrecta',
        message: `Verifica que la CIEC esté escrita correctamente o en su defecto esté actualizada.`,
        client: '',
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: get(notificationObject, 'path')
      };

    case 'ciec_authentication_success':
      return {
        title: 'CIEC correcta',
        message: `La autenticación con la CIEC fue exitosa.`,
        client: '',
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: get(notificationObject, 'path')
      };

    case 'massive_upload_contracts_processed':
      const totalContracts = Number(get(notificationObject, 'params.total', '1'));
      const totalContractsSuccess = Number(get(notificationObject, 'params.total_success', '1'));
      return {
        title: 'Carga de contratos finalizada',
        message: `${totalContractsSuccess} de ${totalContracts} contratos importados correctamente`,
        client: '',
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: get(notificationObject, 'path')
      };

    case 'massive_upload_invoices_processed':
      const totalInvoices = Number(get(notificationObject, 'params.total', '1'));
      const totalInvoicesSuccess = Number(get(notificationObject, 'params.total_success', '1'));
      return {
        title: 'Carga de notas de venta finalizada',
        message: `${totalInvoicesSuccess} de ${totalInvoices} notas de venta importadas correctamente`,
        client: '',
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: get(notificationObject, 'path')
      };

    case 'massive_upload_customers_processed':
      const totalCustomers = Number(get(notificationObject, 'params.total', '1'));
      const totalCustomersSuccess = Number(get(notificationObject, 'params.total_success', '1'));
      return {
        title: 'Carga de clientes finalizada',
        message: `${totalCustomersSuccess} de ${totalCustomers} clientes importados correctamente`,
        client: '',
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: get(notificationObject, 'path')
      };

    case 'massive_upload_payments_processed':
      const totalPayments = Number(get(notificationObject, 'params.total', '1'));
      const totalPaymentsSuccess = Number(get(notificationObject, 'params.total_success', '1'));
      return {
        title: 'Carga de pagos finalizada',
        message: `${totalPaymentsSuccess} de ${totalPayments} pagos importados correctamente`,
        client: '',
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: get(notificationObject, 'path')
      };

    case 'dispersion_failed':
      const paymentClabe = get(notificationObject, 'params.request_dispersion_clabe', null);
      const reference = get(notificationObject, 'params.reference', null);
      const clabeText = paymentClabe ? ` a la cuenta ${paymentClabe}` : '';
      const referenceText = reference ? ` con referencia ${reference}` : '';
      return {
        title: 'Error en dispersión de pago',
        message: `No se pudo completar la dispersión del pago${clabeText}${referenceText}. Por favor, contacta a soporte para más información.`,
        client: '',
        date: parseTopbarNotificationsDate(notificationObject.created_at),
        path: window.location.pathname
      };

    default:
      return {};
  } // END switch
}); // END parseTopbarNotifications

// --------------- SAT ERRORS ---------------
export const satErrors = {};

let satErrrorCode = (satErrors.parseSatErrors = function (code) {
  switch (code) {
    case 401:
      return {
        description: 'Error con el archivo .key.'
      };

    case 402:
      return {
        description: 'El certificado no corresponde con el RFC.'
      };

    case 403:
      return {
        description: 'El archivo no es un certificado válido.'
      };

    case 405:
      return {
        description: 'No hay correspondencia entre los archivos, es posible que hayas introducido la FIEL.'
      };

    case 406:
      return {
        description: 'La clave CIEC es incorrecta.'
      };

    default:
      return {};
  } // END switch
}); // END parseSatErrors

// --------------- CHECKOUT ---------------

export const checkout = {};

const planName = (checkout.planName = (activeTab, plan) => {
  let planName;

  if (activeTab === 1 && plan === 6) planName = 'Plan Básico Mensual';
  if (activeTab === 1 && plan === 8) planName = 'Plan PRO Mensual';
  if (activeTab === 2 && plan === 6) planName = 'Plan Básico Anual';
  if (activeTab === 2 && plan === 8) planName = 'Plan PRO Anual';

  return `Suscripción ${planName}`;
}); // END  planName

const planPrice = (checkout.planPrice = (activeTab, plan) => {
  let planPrice;

  if (activeTab === 1 && plan === 6) planPrice = 499;
  if (activeTab === 1 && plan === 8) planPrice = 999;
  if (activeTab === 2 && plan === 6) planPrice = 5988;
  if (activeTab === 2 && plan === 8) planPrice = 11988;

  return planPrice;
}); // END  planPrice

const planDiscount = (checkout.planDiscount = (activeTab, plan) => {
  let planDiscount;

  if (activeTab === 2 && plan === 6) planDiscount = 1200;
  if (activeTab === 2 && plan === 8) planDiscount = 2400;

  return planDiscount;
}); // END  planDiscount

const planTotal = (checkout.planTotal = (activeTab, plan) => {
  let planPrice;

  if (activeTab === 1 && plan === 6) planPrice = 499;
  if (activeTab === 1 && plan === 8) planPrice = 999;
  if (activeTab === 2 && plan === 6) planPrice = 4788;
  if (activeTab === 2 && plan === 8) planPrice = 9588;

  return planPrice;
}); // END  planTotal

const parsePlanID = (checkout.parsePlanID = (activeTab, plan) => {
  let planID;

  if (activeTab == 1 && plan == 6) planID = BASIC;
  if (activeTab == 2 && plan == 6) planID = BASIC_ANUAL;
  if (activeTab == 1 && plan == 8) planID = PRO;
  if (activeTab == 2 && plan == 8) planID = PRO_ANUAL;

  return planID;
}); // END  parsePlanID

const packageCatalog = (checkout.packages = {
  // NOTE: The pricing key is wihtout IVA and the price key is with IVA
  // Plans
  pc_premium_2022_men_v2_0: {
    id: 'pc_premium_2022_men_v2_0',
    name: 'Premium',
    pricing: '$6,400 MXN',
    price: 7424,
    period: 'Mensual',
    promotion: '',
    originalPrice: '',
    discount: null,
    bundle: 'pc_premium_2022',
    order: 1
  },
  pc_premium_2022_tri_v2_0: {
    id: 'pc_premium_2022_tri_v2_0',
    name: 'Premium',
    pricing: '$19,200 MXN',
    price: 22272,
    period: 'Trimestral',
    promotion: '',
    originalPrice: '',
    discount: null,
    bundle: 'pc_premium_2022',
    order: 2
  },
  pc_premium_2022_sem_v2: {
    id: 'pc_premium_2022_sem_v2',
    name: 'Premium',
    pricing: '$38,400 MXN',
    price: 44544,
    period: 'Semestral',
    promotion: '',
    originalPrice: '',
    discount: null,
    bundle: 'pc_premium_2022',
    order: 3
  },
  pc_premium_2022_anu_v2_0: {
    id: 'pc_premium_2022_anu_v2_0',
    name: 'Premium',
    pricing: '$76,800 MXN',
    price: 89088,
    period: 'Anual',
    promotion: '',
    originalPrice: '',
    discount: null,
    bundle: 'pc_premium_2022',
    order: 4
  },

  pc_professional_2022_men_v2_0: {
    id: 'pc_professional_2022_men_v2_0',
    name: 'Professional',
    pricing: '$4,400 MXN',
    price: 5104,
    period: 'Mensual',
    promotion: '',
    originalPrice: '',
    discount: null,
    bundle: 'pc_professional_2022',
    order: 1
  },

  pc_professional_2022_tri_v2_1: {
    id: 'pc_professional_2022_tri_v2_1',
    name: 'Professional',
    pricing: '$13,200 MXN',
    price: 15312,
    period: 'Trimestral',
    promotion: '',
    originalPrice: '',
    discount: null,
    bundle: 'pc_professional_2022',
    order: 2
  },
  pc_professional_2022_sem_v2_0: {
    id: 'pc_professional_2022_sem_v2_0',
    name: 'Professional',
    pricing: '$26,400 MXN',
    price: 30624,
    period: 'Semestral',
    promotion: '',
    originalPrice: '',
    discount: null,
    bundle: 'pc_professional_2022',
    order: 3
  },
  pc_professional_2022_anu_v2_0: {
    id: 'pc_professional_2022_anu_v2_0',
    name: 'Professional',
    pricing: '$52,800 MXN',
    price: 61248,
    period: 'Anual',
    promotion: '',
    originalPrice: '',
    discount: null,
    bundle: 'pc_professional_2022',
    order: 4
  },

  extra_user: {
    id: 'extra_user',
    name: 'Usuario extra',
    pricing: '$399/mes',
    price: 399.0,
    period: 'Mensual',
    promotion: 'También puedes contratar un plan, cada plan incluye usuarios',
    cta: 'Ahorra un 20% con un plan anual',
    bundle: []
  },

  extra_client: {
    id: 'extra_client',
    name: 'Cliente extra',
    pricing: '$20/mes/cliente',
    price: 20.0,
    period: 'Mensual',
    promotion: null,
    cta: 'Muchos clientes?, contrata un plan y aumenta la cantidad de inmediato',
    bundle: []
  },

  // Packages
  code100FoliosPlan: {
    id: 'code100FoliosPlan',
    name: 'Paquete de 100 Folios',
    pricing: '$180.00',
    price: 180.0,
    period: 'Consumible',
    cta: 'Felicidades, estás ahorrando en la compra de 100 folios',
    bundle: ['code300FoliosPlan', 'code500FoliosPlan', 'code1000FoliosPlan']
  },

  code300FoliosPlan: {
    id: 'code300FoliosPlan',
    name: 'Paquete de 300 Folios',
    pricing: '$360.00',
    price: 360.0,
    period: 'Consumible',
    cta: 'Felicidades, estás ahorrando en la compra de 300 folios',
    bundle: ['code100FoliosPlan', 'code500FoliosPlan', 'code1000FoliosPlan']
  },

  code500FoliosPlan: {
    id: 'code500FoliosPlan',
    name: 'Paquete de 500 Folios',
    pricing: '$525.00',
    price: 525.0,
    period: 'Consumible',
    cta: 'Felicidades, estás ahorrando en la compra de 500 folios',
    bundle: ['code100FoliosPlan', 'code300FoliosPlan', 'code1000FoliosPlan']
  },

  code1000FoliosPlan: {
    id: 'code1000FoliosPlan',
    name: 'Paquete de 1000 Folios',
    pricing: '$900.00',
    price: 900.0,
    period: 'Consumible',
    cta: 'Felicidades, estás ahorrando en la compra de 1000 folios',
    bundle: ['code100FoliosPlan', 'code300FoliosPlan', 'code500FoliosPlan']
  },

  code100Folios: {
    id: 'code100Folios',
    name: 'Paquete de 100 Folios',
    pricing: '$180.00',
    price: 180.0,
    period: 'Consumible',
    cta: 'Al contratar un plan: $135.00',
    bundle: ['code300Folios', 'code500Folios', 'code1000Folios']
  },

  code300Folios: {
    id: 'code300Folios',
    name: 'Paquete de 300 Folios',
    pricing: '$540.00',
    price: 540.0,
    period: 'Consumible',
    cta: 'Al contratar un plan: $360.00',
    bundle: ['code100Folios', 'code500Folios', 'code1000Folios']
  },

  code500Folios: {
    id: 'code500Folios',
    name: 'Paquete de 500 Folios',
    pricing: '$900.00',
    price: 900.0,
    period: 'Consumible',
    cta: 'Al contratar un plan: $525.00',
    bundle: ['code100Folios', 'code300Folios', 'code1000Folios']
  },

  code1000Folios: {
    id: 'code1000Folios',
    name: 'Paquete de 1000 Folios',
    pricing: '$1,800.00',
    price: 1800.0,
    period: 'Consumible',
    cta: 'Al contratar un plan: $900.00',
    bundle: ['code100Folios', 'code300Folios', 'code500Folios']
  },

  code500Descargas: {
    id: 'code500Descargas',
    name: 'Paquete de 500 Descargas',
    pricing: '$50',
    price: 50,
    period: 'Consumible',
    promotion: null,
    cta: 'Las descargas te permiten importar tus facturas y clientes desde el SAT',
    bundle: null
  },

  code500DescargasPlan: {
    id: 'code500Descargas',
    name: 'Paquete de 500 Descargas',
    pricing: '$50',
    price: 50,
    period: 'Consumible',
    promotion: null,
    cta: 'Las descargas te permiten importar tus facturas y clientes desde el SAT',
    bundle: null
  },
  [CREDITS_OPTION_ONE.id]: {
    id: CREDITS_OPTION_ONE.id,
    name: 'Paquete de 100 Creditos',
    pricing: '$199.00',
    price: 230.84,
    period: '100 Créditos',
    cta: '',
    bundle: [CREDITS_OPTION_TWO.id, CREDITS_OPTION_THREE.id, CREDITS_OPTION_FOUR.id],
    order: 1
  },
  [CREDITS_OPTION_TWO.id]: {
    id: CREDITS_OPTION_TWO.id,
    name: 'Paquete de 500 Creditos',
    pricing: '$749.00',
    price: 868.84,
    period: '500 Créditos',
    cta: 'Ahorras 25%',
    bundle: [CREDITS_OPTION_ONE.id, CREDITS_OPTION_THREE.id, CREDITS_OPTION_FOUR.id],
    order: 2
  },
  [CREDITS_OPTION_THREE.id]: {
    id: CREDITS_OPTION_THREE.id,
    name: 'Paquete de 1000 Creditos',
    pricing: '$999.00',
    price: 1158.84,
    period: '1000 Créditos',
    cta: 'Ahorras 50%',
    bundle: [CREDITS_OPTION_ONE.id, CREDITS_OPTION_TWO.id, CREDITS_OPTION_FOUR.id],
    order: 3
  },
  [CREDITS_OPTION_FOUR.id]: {
    id: CREDITS_OPTION_FOUR.id,
    name: 'Paquete de 2000 Creditos',
    pricing: '$1,799.00',
    price: 2086.84,
    period: '2000 Créditos',
    cta: 'Ahorras 60%',
    bundle: [CREDITS_OPTION_ONE.id, CREDITS_OPTION_TWO.id, CREDITS_OPTION_THREE.id],
    order: 4
  },
  premiumUsers: {
    id: 'code1UsersPremium',
    name: 'Usuario extra',
    price: 346.84,
    priceWithoutIva: 299,
    currency: 'MXN',
    quantity: 1,
    cta: null,
    bundle: null
  },
  professionalUsers: {
    id: 'code1Users',
    name: 'Usuario extra',
    price: 578.84,
    priceWithoutIva: 499,
    currency: 'MXN',
    quantity: 1,
    cta: null,
    bundle: null
  },
  code100Customers: {
    id: 'code100Customers',
    amount: 100,
    price: 1160,
    priceWithoutIva: 1000,
    name: 'Paquete 100 clientes $10.00 MXN c/u'
  }
}); // END packageCatalog

const checkoutYears = (checkout.years = [
  { label: '2022', value: '22' },
  { label: '2023', value: '23' },
  { label: '2024', value: '24' },
  { label: '2025', value: '25' },
  { label: '2026', value: '26' },
  { label: '2027', value: '27' },
  { label: '2028', value: '28' },
  { label: '2029', value: '29' },
  { label: '2030', value: '30' },
  { label: '2031', value: '31' },
  { label: '2032', value: '32' },
  { label: '2033', value: '33' }
]); // END checkoutYears

const checkoutMonts = (checkout.months = [
  { label: 'Enero', value: '01' },
  { label: 'Febrero', value: '02' },
  { label: 'Marzo', value: '03' },
  { label: 'Abril', value: '04' },
  { label: 'Mayo', value: '05' },
  { label: 'Junio', value: '06' },
  { label: 'Julio', value: '07' },
  { label: 'Agosto', value: '08' },
  { label: 'Septiembre', value: '09' },
  { label: 'Octubre', value: '10' },
  { label: 'Noviembre', value: '11' },
  { label: 'Diciembre', value: '12' }
]); // END checkoutMonts

// --------------- Contract ---------------
export const contract = {};
let contract_status = (contract.getStatus = function (contract = {}) {
  let { status = 'active' } = contract,
    statusConfig;
  const { ended_at } = contract;

  if (status === 'active' && ended_at && moment.unix(ended_at).isBefore()) {
    status = 'complete';
  }

  switch (status) {
    case 'active':
      statusConfig = {
        value: 'Activo',
        color: '#2692b0'
      };
      break;

    case 'paused':
      statusConfig = {
        value: 'Pausado',
        color: '#6c757d'
      };
      break;

    case 'canceled':
      statusConfig = {
        value: 'Cancelado',
        color: '#8E8E8E'
      };
      break;

    case 'complete':
      statusConfig = {
        value: 'Completado',
        color: '#4bbc68'
      };
      break;

    default:
      statusConfig = {
        value: 'No disponible',
        color: '#314e7d'
      };
      break;
  }

  return statusConfig;
});

// --------------- Filters ---------------
export const tagFilters = {};

let tagFilterCondition = (tagFilters.parseTagFilterCondition = function (filterCondition) {
  switch (filterCondition) {
    case 'cont':
      return 'contiene';

    case 'eq':
      return 'igual a';

    case 'ne':
      return 'diferente a';

    case 'sw':
      return 'empieza con';

    case 'ew':
      return 'termina con';

    case 'ncont':
      return 'no contiene';

    case 'gt':
      return 'mayor que';

    case 'gte':
      return 'mayor o igual que';

    case 'lt':
      return 'menor que';

    case 'lte':
      return 'menor o igual que';

    default:
      return 'No disponible';

      break;
  } // END switch
}); // END tagFilterCondition

// -------------- Status Contpaqi --------------------

export const contpaqiStatus = {};

let contpaqiStatusCondition = (contpaqiStatus.typeStatus = function (status) {
  switch (status) {
    case 'active':
      return {
        color: '#4BBC68',
        status: 'Activo',
        message: ''
      };

    case 'request_payments':
      return {
        color: '#4BBC68',
        status: 'Solicitando pagos',
        message: 'Se solicitaron los pagos a contpaqi para validar el balance en ambas plataformas'
      };

    case 'unknown':
      return {
        color: '#FA6400',
        status: 'Desconocido',
        message: 'No se tienen datos de la factura por problemas de conexión con la integracion'
      };

    case 'error_balance':
      return {
        color: '#E9494E',
        status: 'Error de balance',
        message:
          'Existe un error con el cálculo de balance, se debe ajustar en ambas plataformas y solicitar de nuevo su descarga'
      };

    case 'not_found':
      return {
        color: '#FA6400',
        status: 'No encontrado',
        message: 'Factura no enontrada en el listado de CONTPAQi'
      };

    case 'not_supported':
      return {
        color: '#FA6400',
        status: 'Documento no soportado',
        message: 'Existe una nota de crédito de lado de PorCobrar, no se pueden insertar notas de crédito en CONTPAQI'
      };

    case 'error_insert':
      return {
        color: '#E9494E',
        status: 'Error de inserción',
        message: 'Hubo un error en la inserción de un pago ó de una nota de crédito'
      };

    default:
      return {
        color: '#FA6400',
        status: 'No encontrado',
        message: 'Factura no enontrada en el listado de CONTPAQi'
      };
  } //END switch
}); // END contpaqiStatusCondition

/**
 * Descriptive error messages for users in domiciled
 * @param {string} status - Domiciliation status error
 */

export const domiciledStatus = function (status) {
  switch (status) {
    case 'authentication_required':
      return 'Autenticación requerida, se recomienda utilizar otra tarjeta';

    case 'call_issuer':
      return 'Problemas en la cuenta, se recomienda contactar al banco';

    case 'expired_card':
      return 'La tarjeta a expirado';

    case 'insufficient_funds':
      return 'Saldo insuficiente en la tarjeta';

    case 'lost_card':
      return 'La tarjeta fue reportada como robada o extraviada';

    case 'merchant_blacklist':
      return 'La tarjeta se encuentra dentro de la lista negra';

    case 'not_permitted':
      return 'La tarjeta no permite cobros en linea';

    case 'restricted_card':
      return 'Existen restricciones de parte del banco';

    default:
      return status || 'Error desconocido, favor de revisar con tu banco';
  } //END switch
}; // END domiciledStatusCondition



// WEBPACK FOOTER //
// ./src/libs/statusCatalog.js